module.exports = __webpack_public_path__ + "img/31.7f13a522.jpg";